<template>
  <div class="formdata monument">
    <div class="header-container">
    <h3 id="monument_question">Steht das Haus unter Denkmalschutz?</h3>
</div>
    <CustomRadioGroup
        :options="monumentAnswers"
        v-model="selectedAnswer"
        aria-labelledby="monument_question"
        :unique="monumentQuestion"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'monument_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>



    <button class="button button_yellow right" v-if="selectedAnswer" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useWorkflowStore} from '../../stores/workflow.js';
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";
import {monumentAnswers, monumentApi} from "@/data/monumentData";

const workflowStore = useWorkflowStore();


const getEventData = (selectedValue) => {
  const fullAnswer = monumentAnswers.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: monumentApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available
    };
  }
  return null;
};


const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.monument || null;
  },
  set(newValue) {
    // Der Setter wird aufgerufen, sobald der Benutzer einen Radio-Button auswählt.
    // Hier senden wir ein Event, das den Wert sofort im Store aktualisiert.
    const eventData = getEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_MONUMENT_ANSWER',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedAnswer.value) {
    const eventData = getEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>




</style>